import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import actions from './promo_code.actions';

import type { PromoCode } from './promo_code.types';
import type { LoadingStatus } from 'types/common_types';

export type PromoCodeState = {
  status: LoadingStatus;
  message?: string;
  valid?: PromoCode;
};

const initialState: PromoCodeState = {
  status: 'idle',
};

const slice = createSlice({
  name: 'promoCode',
  initialState,
  reducers: {
    clearPromoError(state) {
      return { ...state, status: 'idle', message: undefined };
    },
    setValidPromoCode(state, { payload }: PayloadAction<PromoCode>) {
      return {
        ...state,
        status: 'idle',
        valid: payload,
      };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(actions.save.fulfilled, (state, { payload }) => {
        return {
          ...state,
          status: 'idle',
          message: undefined,
          valid: payload || undefined,
        };
      })
      .addCase(actions.save.invalid, (state, { payload }) => {
        return {
          ...state,
          status: 'error',
          message: payload,
        };
      })
      .addCase(actions.getDetails.fulfilled, (state, { payload }) => {
        return {
          ...state,
          status: 'idle',
          message: undefined,
          valid: payload,
        };
      });
  },
});

export default slice;
